(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["agw-currency"] && !Shopify.designMode) return;
  try {
    (() => {
  const config = document.getElementById('agw-currency-config');
  if (!config || customElements.get('agw-money')) return;
  const countries = { MA: 'MAD', DZ: 'DZD', DE: 'EUR', SA: 'SAR', BE: 'EUR', CA: 'CAD', AE: 'AED', ES: 'EUR', US: 'USD', FR: 'EUR', IN: 'INR', IT: 'EUR', PT: 'EUR', QA: 'QAR', GB: 'GBP', CH: 'CHF', TN: 'TND', UA: 'UAH' };
  const base = config.dataset.base;
  const target = countries[config.dataset.country] || base;
  const eligible = base === 'MAD' && !config.dataset.page.startsWith('customers/') && config.dataset.page !== 'gift_card';
  const key = 'agw-fx-mad-v1';
  const day = 86400000;
  const bus = new EventTarget();
  let payload = null;
  let expiryTimer;
  const fresh = data => data && data.result === 'success' && data.base_code === 'MAD' && data.rates && data.rates.MAD === 1 && Number.isFinite(data.time_last_update_unix) && data.time_last_update_unix * 1000 <= Date.now() + 3600000 && Date.now() - data.time_last_update_unix * 1000 < 3 * day;
  const rateFor = code => fresh(payload) && Number.isFinite(payload.rates[code]) && payload.rates[code] > 0 ? payload.rates[code] : null;
  const active = () => eligible && target !== base && rateFor(target) !== null;
  const formatters = new Map();
  const format = (amount, code) => {
    if (!formatters.has(code)) formatters.set(code, new Intl.NumberFormat(config.dataset.locale || 'fr', { style: 'currency', currency: code, currencyDisplay: 'code' }));
    return formatters.get(code).format(amount);
  };
  const refresh = () => bus.dispatchEvent(new Event('rates'));
  const apply = data => {
    if (!fresh(data)) return false;
    payload = data;
    clearTimeout(expiryTimer);
    expiryTimer = setTimeout(refresh, Math.max(1, data.time_last_update_unix * 1000 + 3 * day - Date.now()));
    refresh();
    return true;
  };
  class CurrencyElement extends HTMLElement {
    connectedCallback() {
      this.listener = () => this.render();
      bus.addEventListener('rates', this.listener);
      this.render();
    }
    disconnectedCallback() { bus.removeEventListener('rates', this.listener); }
  }
  class Money extends CurrencyElement {
    static get observedAttributes() { return ['data-amount', 'data-base']; }
    connectedCallback() {
      if (this.original === undefined) this.original = this.innerHTML;
      super.connectedCallback();
    }
    attributeChangedCallback() { if (this.isConnected && this.original !== undefined) this.render(); }
    render() {
      const amount = Number(this.dataset.amount);
      if (this.dataset.amount && Number.isFinite(amount) && amount >= 0 && this.dataset.base === base && active() && !this.closest('[data-agw-no-convert]')) {
        const value = format(amount / 100 * rateFor(target), target);
        if (this.textContent !== value) this.textContent = value;
        this.dataset.converted = target;
      } else {
        if (this.dataset.converted && this.innerHTML !== this.original) this.innerHTML = this.original;
        delete this.dataset.converted;
      }
    }
  }
  class Label extends CurrencyElement {
    connectedCallback() { if (this.original === undefined) this.original = this.textContent; super.connectedCallback(); }
    render() {
      const code = countries[this.dataset.country];
      const value = eligible && code && rateFor(code) ? code : this.original;
      if (this.textContent !== value) this.textContent = value;
    }
  }
  class Note extends CurrencyElement { render() { this.hidden = !active(); } }
  class Credit extends CurrencyElement { render() { this.hidden = !eligible || !fresh(payload); } }
  class Shipping extends HTMLElement {
    connectedCallback() {
      this.bar = this.querySelector('free-shipping-bar');
      if (!this.bar) return;
      this.observer = new MutationObserver(records => {
        if (records.some(record => record.type === 'attributes' || record.target === this.bar.querySelector('span'))) this.render();
      });
      this.observer.observe(this.bar, { childList: true, subtree: true, attributes: true, attributeFilter: ['total-price', 'threshold'] });
      this.listener = () => this.render();
      bus.addEventListener('rates', this.listener);
      customElements.whenDefined('free-shipping-bar').then(() => { if (this.isConnected) this.render(); });
    }
    disconnectedCallback() { this.observer?.disconnect(); bus.removeEventListener('rates', this.listener); }
    render() {
      if (!this.bar || !customElements.get('free-shipping-bar')) return;
      const threshold = Number(this.bar.getAttribute('threshold'));
      const total = Number(this.bar.getAttribute('total-price'));
      const span = this.bar.querySelector('span');
      if (!span || !Number.isFinite(threshold) || !Number.isFinite(total) || total >= threshold) return;
      const amount = threshold - total;
      const current = span.querySelector('agw-money');
      if (current && Number(current.dataset.amount) === amount) return;
      const money = document.createElement('agw-money');
      money.dataset.amount = String(amount);
      money.dataset.base = base;
      money.textContent = format(amount / 100, base);
      const template = this.bar.getAttribute('unreached-message') || '';
      const html = template.replace(/\{\{[^}]+\}\}/g, money.outerHTML);
      if (span.innerHTML !== html) span.innerHTML = html;
    }
  }
  customElements.define('agw-money', Money);
  customElements.define('agw-currency-label', Label);
  customElements.define('agw-currency-note', Note);
  customElements.define('agw-currency-credit', Credit);
  customElements.define('agw-shipping-conversion', Shipping);
  if (!eligible) return;
  try { apply(JSON.parse(localStorage.getItem(key))); } catch (_) {}
  const nextUpdate = payload && Number(payload.time_next_update_unix) * 1000;
  if (payload && nextUpdate > Date.now() && nextUpdate <= Date.now() + 2 * day) return;
  const controller = new AbortController();
  const timeout = setTimeout(() => controller.abort(), 5000);
  fetch('https://open.er-api.com/v6/latest/MAD', { signal: controller.signal, credentials: 'omit', referrerPolicy: 'no-referrer' })
    .then(response => { if (!response.ok) throw new Error('Rates unavailable'); return response.json(); })
    .then(data => { if (apply(data)) { try { localStorage.setItem(key, JSON.stringify(data)); } catch (_) {} } })
    .catch(() => {})
    .finally(() => clearTimeout(timeout));
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["agw-interface-fixes"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('agw-interface-fixes')) {
    customElements.define('agw-interface-fixes', class extends HTMLElement {
      connectedCallback() {
        const update = () => {
          this.frame = null;
          const label = this.dataset.savings;
          if (!label) return;
          document.querySelectorAll('.discounty-cart-widget__saving-label').forEach(element => {
            if (element.textContent !== label) element.textContent = label;
          });
        };
        this.observer = new MutationObserver(() => {
          if (this.frame == null) this.frame = requestAnimationFrame(update);
        });
        this.observer.observe(document.body, {childList: true, subtree: true, characterData: true});
        update();
      }
      disconnectedCallback() {
        this.observer?.disconnect();
        if (this.frame != null) cancelAnimationFrame(this.frame);
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
